import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import { FragmentNames, ScoreNrsListAliases } from '../../../../codegen/index';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../../constants/routes';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import InformationBarUtils from '../../../../controllers/commons/header/information-bar-header-utils';
import { ScoreAndIndexesService } from '../../scores-list/scores-list-service';
import { ScoresAndIndexesStatusType } from '../../score-types';

@Controller({ component: ScoreNrsListAliases.LAYOUT_SCORE_NRS_LIST, fragment: FragmentNames.SCORE_NRS_LIST})
export default class ScoreNrsListController extends BaseController {

  @Inject(ScoreNrsListAliases.PANEL_GLOBAL_ACTIONS)
  private panelGlobalActions!: PanelAPI;

  @OnMount({ target: ScoreNrsListAliases.PANEL_GLOBAL_ACTIONS })
  handlePanelGlobalActionsMount(): void {
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    this.panelGlobalActions.setVisible(allowInfo);
  }

  @OnClick({ target: ScoreNrsListAliases.ADD_SCORE_NRS_CUSTOM_DYNAMIC_BUTTON })
  handleOnClick(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(
      ApplicationRoute.SCORE_NRS_CREATE, {
        encounterId,
        patientId,
      }
    )
  }

  @OnClick({ target: ScoreNrsListAliases.DECK_SCORE_NRS })
  handleClickCard(event: ClickEvent): void {
    const { idScoreIndexes, status } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    const accessViewer = ((status === ScoresAndIndexesStatusType.ACTIVE) || (!allowInfo))
    const route = accessViewer ? ApplicationRoute.SCORE_NRS_VIEWER : ApplicationRoute.SCORE_NRS_EDIT;

    applicationContext.redirect(route, {
      encounterId,
      idScoreIndexes,
      patientId,
    });
  }
}
